<template>
  <div class="p-3 min-h-[80vh]">
    <button
      @click="closeMode"
      class="bg-blue-500 p-2 text-white text-xs rounded hover:bg-blue-600"
    >
      <font-awesome-icon icon="fa-solid fa-angles-left" class="mr-1" />
      Буцах
    </button>

    <h1 class="mt-5 text-center font-bold">Уулзалтын өдөр, цаг нэмэх</h1>

    <div class="mb-3">
      <label for="date">Өдөр:<span class="text-red-500">*</span></label>
      <input
        id="date"
        name="date"
        type="date"
        class="border rounded w-full p-2"
        v-model="form.date"
      />
    </div>

    <div class="flex gap-10 mb-3 w-full">
      <div class="w-full">
        <label for="start_time"
          >Тухайн өдрийн эхний уулзалтын эхлэх цаг:<span class="text-red-500"
            >*</span
          ></label
        >
        <input
          id="start_time"
          name="start_time"
          type="time"
          step="3600"
          class="border rounded w-full p-2"
          v-model="form.start_time"
        />
      </div>

      <div class="w-full">
        <label for="end_time"
          >Тухайн өдрийн сүүлийн уулзалтын эхлэх цаг:<span class="text-red-500"
            >*</span
          ></label
        >
        <input
          id="end_time"
          name="end_time"
          type="time"
          step="3600"
          class="border rounded w-full p-2"
          v-model="form.end_time"
        />
      </div>
    </div>

    <div class="flex items-center text-xs">
      <button
        @click="addMeetingTime()"
        class="bg-blue-500 p-2 rounded text-white mr-2 hover:scale-105"
      >
        <font-awesome-icon icon="fa-solid fa-add" class="mr-1" />Нэмэх
      </button>
      <button
        @click="resetForm()"
        class="bg-amber-500 p-2 rounded text-white hover:scale-105"
      >
        <font-awesome-icon icon="fa-solid fa-eraser" class="mr-1" />Арилгах
      </button>
    </div>
  </div>

  <success-modal v-if="success" :success="success" />
  <error-modal v-if="error" :error="error" />
</template>

<script>
import adminInstance from "@/lib/adminInstance";
import { ref } from "vue";
import SuccessModal from "@/components/ui/SuccessModal.vue";
import ErrorModal from "@/components/ui/ErrorModal.vue";

export default {
  name: "YellowAddMeetingTime",
  emits: ["closeMode"],
  components: {
    SuccessModal,
    ErrorModal,
  },
  setup(_, { emit }) {
    const closeMode = () => {
      resetForm();
      emit("closeMode");
    };

    const success = ref(null);
    const error = ref(null);
    const form = ref({
      date: null,
      start_time: null,
      end_time: null,
    });

    const resetForm = () => {
      form.value = {
        date: null,
        start_time: null,
        end_time: null,
      };
    };

    const isValid = () => {
      if (!form.value.date) return alert("Өдрөө оруулна уу");
      if (!form.value.start_time) return alert("Эхлэх цагийг оруулна уу");
      if (!form.value.end_time) return alert("Дуусах цагийг оруулна уу");

      return true;
    };

    const addMeetingTime = async () => {
      if (!isValid()) return;

      try {
        const res = await adminInstance.post(
          "/yellow-page/insert/meeting-time",
          form.value
        );
        if (res.status === 200) {
          success.value = "Амжилттай нэмэгдлээ.";
          resetForm();
          setTimeout(() => {
            success.value = false;
          }, 5000);
        }
      } catch (err) {
        error.value = "Алдаа гарлаа.";
        setTimeout(() => {
          error.value = false;
        }, 5000);
      }
    };

    return { closeMode, form, resetForm, addMeetingTime, success, error };
  },
};
</script>
